function detectIE() {
    var ua = window.navigator.userAgent;

    // Test values; Uncomment to check result …

    // IE 10
    // ua = 'Mozilla/5.0 (compatible; MSIE 10.0; Windows NT 6.2; Trident/6.0)';

    // IE 11
    // ua = 'Mozilla/5.0 (Windows NT 6.3; Trident/7.0; rv:11.0) like Gecko';

    // Edge 12 (Spartan)
    // ua = 'Mozilla/5.0 (Windows NT 10.0; WOW64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/39.0.2171.71 Safari/537.36 Edge/12.0';

    // Edge 13
    // ua = 'Mozilla/5.0 (Windows NT 10.0; Win64; x64) AppleWebKit/537.36 (KHTML, like Gecko) Chrome/46.0.2486.0 Safari/537.36 Edge/13.10586';

    var msie = ua.indexOf('MSIE ');
    if (msie > 0) {
        // IE 10 or older => return version number
        return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
    }

    var trident = ua.indexOf('Trident/');
    if (trident > 0) {
        // IE 11 => return version number
        var rv = ua.indexOf('rv:');
        return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
    }

    var edge = ua.indexOf('Edge/');
    if (edge > 0) {
        // Edge (IE 12+) => return version number
        return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
    }

    // other browser
    return false;
}

if (detectIE() != false) {

    document.getElementsByTagName("html")[0].classList.add("ie11");
}


$(document).ready(function () {

    /*$("a").on('click', function(event) {

        // Make sure this.hash has a value before overriding default behavior
        if (this.hash !== "") {
            // Prevent default anchor click behavior
            event.preventDefault();

            // Store hash
            var hash = this.hash;

            // Using jQuery's animate() method to add smooth page scroll
            // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
            $('html, body').animate({
                scrollTop: $(hash).offset().top
            }, 400, function(){

                // Add hash (#) to URL when done scrolling (default click behavior)
                window.location.hash = hash;
            });
        } // End if
    });*/

    let slickstories = $('.slick-stories');

    slickstories.slick({
        dots: true,
        slidesToShow: 4,

    });

    let slickteam = $('.el-team--slider__slide');

    slickteam.slick({
        dots: true,
        slidesToShow: 3,
    });


    //mobile nav
    function endAnimaation() {
        menu.one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend', function () {
            if (menu.hasClass('fadeInDown')) {
                //console.log('ende mit fadeindown');
            } else {
                //console.log('alles löschen');
                menu
                    .removeClass('animated fadeOutUp active')
                    .attr('style', '');
                html
                    .removeClass('fixed-header');
            }

        });
    }

    var menuToggle = $("#menu-toggle");
    var menu = $("#menu");
    var html = $('html');

    menuToggle.click(function (e) {

        if (menu.hasClass('active')) {
            menuToggle
                .removeClass('active')
                .attr('aria-expanded', false);
            menu
                .removeClass('fadeInDown')
                .addClass('fadeOutUp');
            endAnimaation();
        } else {
            html
                .addClass('fixed-header');
            menuToggle
                .addClass('active')
                .attr('aria-expanded', true);
            menu.addClass('active fadeInDown animated');
        }

    });


    $(".el-media--btn").click(function (e) {
        const medialist = $('.el-media__entry');
        const medialisthide = $('[data-row="hide"]');

        if ($(this).text() == 'Mehr anzeigen') {
            medialist.removeClass('hidden');
            $(this).text('Weniger anzeigen');
        } else {
            medialisthide.addClass('hidden');
            $(this).text('Mehr anzeigen');
        }
        e.preventDefault();
    });


    const scroll = $('.el-ref__table-scroll');
    $('.el-ref__map-info.scroll-down').hover(function (e) {
        scroll.hide();

    }, function () {
        if ($(window).width() > 940) {
            if ($(this).hasClass('scroll-down')) {
                scroll.show();
            }

        }
    });


    $('.cookie-change').click(function (e) {
        //console.log('click');
        klaro.show();
        e.preventDefault();
    });


    $('.show_on_map').click(function (e) {
        let showmap = $(this).data('loc');
        let showtextinner = $(this).find('.show_on_map_txt');
        $('.el-mapjs__wrapper .el-map__map.gmap').css('z-index', 1);
        $('#gmap_' + showmap).css('z-index', 2);
        $('.show_on_map_txt').show();
        showtextinner.hide();

        e.preventDefault();
    });
});

function showRefMap() {

    if ($('#refmap').length) {

        const refmapMarkers = [];
        const marker = [];
        const refmap = new GMaps({
            el: '#refmap',
            lat: 52.28305556,
            lng: 10.07555556,
            zoom: 8,
            options: {
                mapTypeControl: true,
                streetViewControl: false
            },
            styles: [
                {
                    "featureType": "administrative",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "administrative.province",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "off"
                        }
                    ]
                },
                {
                    "featureType": "landscape",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": 65
                        },
                        {
                            "visibility": "on"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "lightness": "50"
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": "-100"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "all",
                    "stylers": [
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "road.arterial",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "30"
                        }
                    ]
                },
                {
                    "featureType": "road.local",
                    "elementType": "all",
                    "stylers": [
                        {
                            "lightness": "40"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "all",
                    "stylers": [
                        {
                            "saturation": -100
                        },
                        {
                            "visibility": "simplified"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "hue": "#ffff00"
                        },
                        {
                            "lightness": -25
                        },
                        {
                            "saturation": -97
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels",
                    "stylers": [
                        {
                            "lightness": -25
                        },
                        {
                            "saturation": -100
                        }
                    ]
                }
            ]
        });

        const refmap_entries = $('.el-ref__entry');

        const refmapCatURL_WP = '/resources/images/img-single/icon-wp.png';

        const refmapCatURL_BW = '/resources/images/img-single/icon-bw.png';

        const refmapCatURL_UW = '/resources/images/img-single/icon-uw.png';


        refmap_entries.each(function (index) {

            let mapOptions = $(this).data('location');
            let mapEntryCategory = mapOptions[3];
            let refMapIcon;
            let mapKreis = mapOptions[4];
            let mapAnzahlWAE = mapOptions[5];
            let mapLeistung = mapOptions[6];
            let mapProducer = mapOptions[7];

            if (mapEntryCategory == 'bw') {
                refMapIcon = refmapCatURL_BW;
            } else if (mapEntryCategory == 'uw') {
                refMapIcon = refmapCatURL_UW;
            } else {
                refMapIcon = refmapCatURL_WP;
            }


            const marker = refmap.addMarker({
                lat: parseFloat(mapOptions[1]),
                lng: parseFloat(mapOptions[2]),
                title: mapOptions[0],
                category: mapOptions[3],
                mapentryid: mapOptions[8],
                icon: {
                    url: refMapIcon, // url
                    size: new google.maps.Size(20, 20),
                    scaledSize: new google.maps.Size(20, 20)
                },

                infoWindow: {
                    content: '<div class="map_window"><p><strong>' + mapOptions[0] + '</strong><br>' + mapKreis + '<br>' + mapAnzahlWAE + ' <br>' + mapLeistung + '<br>' + mapProducer + '</p></div>'
                }
            });
            refmapMarkers.push(marker);
        });
        var filterMarkers = function (searchtype, search) {
            var bounds = new google.maps.LatLngBounds();
            let i;
            let filtermarker;
            if (searchtype == 'category') {


                //[data-customerID="22"]

                $('[data-category="' + search + '"]').show();

                for (i = 0; i < refmapMarkers.length; i++) {
                    filtermarker = refmapMarkers[i];

                    if (search == '') {
                        filtermarker.setVisible(true);
                        bounds.extend(filtermarker.getPosition());

                    } else if (filtermarker.category == search || search.length == 0) {
                        filtermarker.setVisible(true);
                        bounds.extend(filtermarker.getPosition());


                    }
                    // Categories don't match
                    else {
                        filtermarker.setVisible(false);
                    }
                    //refmap.fitBounds(bounds);
                }
            } else {
                for (i = 0; i < refmapMarkers.length; i++) {

                    filtermarker = refmapMarkers[i];
                    filtermarker.infoWindow.close();
                    if (filtermarker.mapentryid == search || search.length == 0) {
                        filtermarker.setVisible(true);
                        bounds.extend(filtermarker.getPosition());
                        filtermarker.infoWindow.open(refmap, filtermarker);
                        //  refmap.fitBounds(bounds);
                    } else {
                        //filtermarker.setVisible(false);
                    }
                }
            }

        }


        var table = $('#el-ref__table').DataTable({
            paging: false,
            responsive: true,
            "footerCallback": function (row, data, start, end, display) {
                var api = this.api(), data;

                // Remove the formatting to get integer data for summation
                var intVal = function (i) {
                    return typeof i === 'string' ?
                        i.replace(/[\$,]/g, '') * 1 :
                        typeof i === 'number' ?
                            i : 0;
                };
                var floatVal = function (val) {

                    if (val != '') {
                        if (val.indexOf(',') !== -1) {

                            val = val.replace(',', '.');
                        }

                        val = parseFloat(val);

                    }

                    return val;
                }


                //console.log(api.column( 2 ).data());
                // Total over all pages
                let totalwea = api
                    .column(2)
                    .data()
                    .reduce(function (a, b) {
                        return intVal(a) + intVal(b);
                    }, 0);

                // Total over this page
                let pageTotalwea = api
                    .column(2, {page: 'current'})
                    .data()
                    .reduce(function (a, b) {
                        return intVal(a) + intVal(b);
                    }, 0);

                $(api.column(2).footer()).html(
                    pageTotalwea
                );

                let totalmw = api
                    .column(3)
                    .data()
                    .reduce(function (a, b) {

                        return (floatVal(a) + floatVal(b)).toFixed(2);
                    }, 0);

                // Total over this page
                let pageTotalmw = api
                    .column(3, {page: 'current'})
                    .data()
                    .reduce(function (a, b) {


                        return (floatVal(a) + floatVal(b)).toFixed(2);
                    }, 0);

                $(api.column(3).footer()).html(
                    pageTotalmw
                );
            }
        });


        const elrefcat = $('.el-ref__cat');
        var tableentries = $('.el-ref__entry');
        elrefcat.click(function (e) {
            elrefcat.removeClass('active');
            $(this).addClass('active');
            let category = $(this).data('cat');
            filterMarkers('category', category);
            table.draw();
            let tableheight = $('#el-ref__table').height();
            let tablecontainer = $('.el-ref__map-info');
            if (tableheight > 700) {
                tablecontainer.addClass('scroll-down');
            } else {
                tablecontainer.removeClass('scroll-down');
            }
            e.preventDefault();
        });

        tableentries.click(function (e) {
            filterMarkers('point', $(this).data('entryid'));
            e.preventDefault();
        });
        $.fn.dataTable.ext.search.push(
            function (settings, data, dataIndex) {

                let currentCat = $('.el-ref__cat.active').data('cat');
                if (currentCat == '') {
                    return true;
                } else if (currentCat == data[4]) {
                    return true;
                } else {
                    return false;
                }

            }
        );
    }

    if ($('#el-ref__table').length >= 1) {
        table.draw();

    }
}


function showMapContact() {
    const gmaps = $('.gmap');
    console.log('go');
    if (gmaps.length) {
        const contactMapIconURL = '/resources/images/img-single/icon-loc.png';
        const contactMapIcon = {
            url: contactMapIconURL, // url
            size: new google.maps.Size(26, 40),
            scaledSize: new google.maps.Size(26, 40)
        };
        var styles = [
            {
                featureType: "poi.business",
                stylers: [{visibility: "off"}]
            },
            {
                featureType: "poi",
                stylers: [{visibility: "off"}]
            },
            {
                featureType: "transit",
                elementType: "labels.icon",
                stylers: [{visibility: "off"}]
            }
        ];
        gmaps.each(function (index) {

            let mapOptions = $(this).data('location');

            let map = new GMaps({
                el: '#' + $(this).attr('id'),
                lat: parseFloat(mapOptions[2]),
                lng: parseFloat(mapOptions[3]),
                options: {
                    mapTypeControl: true,
                    streetViewControl: false,

                }, styles: styles

            });


            map.addMarker({
                lat: parseFloat(mapOptions[2]),
                lng: parseFloat(mapOptions[3]),
                title: mapOptions[1],
                icon: contactMapIcon
            });
        });
    }
}

$(function () {
    $(window).scroll(function () {
        var header = $('.header');
        if ($(this).scrollTop() > 40) {
            header.addClass('fixed');
        } else {
            header.removeClass('fixed');
        }
    });
});


function startmap() {

    showMapContact();
    showRefMap();
}


/*!
 * @copyright Copyright (c) 2017 IcoMoon.io
 * @license   Licensed under MIT license
 *            See https://github.com/Keyamoon/svgxuse
 * @version   1.2.6
 */
(function () {
    if ("undefined" !== typeof window && window.addEventListener) {
        var e = Object.create(null), l, d = function () {
            clearTimeout(l);
            l = setTimeout(n, 100)
        }, m = function () {
        }, t = function () {
            window.addEventListener("resize", d, !1);
            window.addEventListener("orientationchange", d, !1);
            if (window.MutationObserver) {
                var k = new MutationObserver(d);
                k.observe(document.documentElement, {childList: !0, subtree: !0, attributes: !0});
                m = function () {
                    try {
                        k.disconnect(), window.removeEventListener("resize", d, !1), window.removeEventListener("orientationchange",
                            d, !1)
                    } catch (v) {
                    }
                }
            } else document.documentElement.addEventListener("DOMSubtreeModified", d, !1), m = function () {
                document.documentElement.removeEventListener("DOMSubtreeModified", d, !1);
                window.removeEventListener("resize", d, !1);
                window.removeEventListener("orientationchange", d, !1)
            }
        }, u = function (k) {
            function e(a) {
                if (void 0 !== a.protocol) var c = a; else c = document.createElement("a"), c.href = a;
                return c.protocol.replace(/:/g, "") + c.host
            }

            if (window.XMLHttpRequest) {
                var d = new XMLHttpRequest;
                var m = e(location);
                k = e(k);
                d = void 0 ===
                d.withCredentials && "" !== k && k !== m ? XDomainRequest || void 0 : XMLHttpRequest
            }
            return d
        };
        var n = function () {
            function d() {
                --q;
                0 === q && (m(), t())
            }

            function l(a) {
                return function () {
                    !0 !== e[a.base] && (a.useEl.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", "#" + a.hash), a.useEl.hasAttribute("href") && a.useEl.setAttribute("href", "#" + a.hash))
                }
            }

            function p(a) {
                return function () {
                    var c = document.body, b = document.createElement("x");
                    a.onload = null;
                    b.innerHTML = a.responseText;
                    if (b = b.getElementsByTagName("svg")[0]) b.setAttribute("aria-hidden",
                        "true"), b.style.position = "absolute", b.style.width = 0, b.style.height = 0, b.style.overflow = "hidden", c.insertBefore(b, c.firstChild);
                    d()
                }
            }

            function n(a) {
                return function () {
                    a.onerror = null;
                    a.ontimeout = null;
                    d()
                }
            }

            var a, c, q = 0;
            m();
            var f = document.getElementsByTagName("use");
            for (c = 0; c < f.length; c += 1) {
                try {
                    var g = f[c].getBoundingClientRect()
                } catch (w) {
                    g = !1
                }
                var h = (a = f[c].getAttribute("href") || f[c].getAttributeNS("http://www.w3.org/1999/xlink", "href") || f[c].getAttribute("xlink:href")) && a.split ? a.split("#") : ["", ""];
                var b =
                    h[0];
                h = h[1];
                var r = g && 0 === g.left && 0 === g.right && 0 === g.top && 0 === g.bottom;
                g && 0 === g.width && 0 === g.height && !r ? (f[c].hasAttribute("href") && f[c].setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", a), b.length && (a = e[b], !0 !== a && setTimeout(l({
                    useEl: f[c],
                    base: b,
                    hash: h
                }), 0), void 0 === a && (h = u(b), void 0 !== h && (a = new h, e[b] = a, a.onload = p(a), a.onerror = n(a), a.ontimeout = n(a), a.open("GET", b), a.send(), q += 1)))) : r ? b.length && e[b] && setTimeout(l({
                    useEl: f[c],
                    base: b,
                    hash: h
                }), 0) : void 0 === e[b] ? e[b] = !0 : e[b].onload && (e[b].abort(),
                    delete e[b].onload, e[b] = !0)
            }
            f = "";
            q += 1;
            d()
        };
        var p = function () {
            window.removeEventListener("load", p, !1);
            l = setTimeout(n, 0)
        };
        "complete" !== document.readyState ? window.addEventListener("load", p, !1) : p()
    }
})();
